import React from 'react'
import './Search.css'
import classnames from 'classnames'
import keycode from 'keycode'
import Autosuggest from 'react-autosuggest'
import { convertSearchTextToQuery, convertQueryToSearchText } from './SearchHelpers'

const getSuggestions = (value, searchSuggestions) => {
  const inputValue = value.trim().toLowerCase()
  if(!inputValue || inputValue.length === 0) { return [] }

  const tokens = inputValue.split(' ')
  const last = tokens[tokens.length - 1]
  if(!last || last.search('"') >= 0) { return [] }

  return searchSuggestions.filter(help =>
    (help.name + help.keywords).search(last.toLowerCase()) >= 0
  )
}

const getSuggestionValue = suggestion => suggestion.name

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion.name}
  </div>
)

export default class Search extends React.Component {

  // static propTypes = {
  //   searchSuggestions: React.PropTypes.arrayOf(React.PropTypes.shape({
  //     name: React.PropTypes.string,
  //     keywords: React.PropTypes.string,
  //     template: React.PropTypes.string,
  //     lookupKey: React.PropTypes.string
  //   })),
  //   query: React.PropTypes.func,
  // }

  constructor(props) {
    super(props)
    this.state = {
      focused: false, 
      text: convertQueryToSearchText(this.props.query || {}),
      suggestions: [],
    }
  }

  onFocus = (e) => {
    this.setState({focused: true})
  }

  onBlur = (e) => {
    this.setState({focused: false})
  }

  onKeyDown(e) {
    if (e.keyCode === keycode.codes.enter) {
      if(!this.preventSubmit) {
        this.onSearch(this.state.text)  
      } else {        
        this.preventSubmit = false
        e.preventDefault()
      }
      
    }
  }

  onSearch = (text) => {
    if (this.props.onSearch) {
      let queryObj = convertSearchTextToQuery(text, this.props.searchSuggestions)
      this.props.onSearch(queryObj, text)
    }
  }

  onChange(e) {
    this.setState({
      text: e.target.value
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({text: convertQueryToSearchText(nextProps.query || {})})
  }

  clearSearch = (e) => {
    // this.props.onSearch && this.props.onSearch('')
    // this.setState({text: ''})
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value, this.props.searchSuggestions)
    })
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  onSuggestionSelected = (event, { suggestion }) => {
    const { text } = this.state
    const tokens = text.split(' ')

    tokens[tokens.length - 1] = suggestion.template
    this.preventSubmit = true
    this.setState({text: tokens.join(' '), preventSubmit: true})
  }

  render() {
    const { focused, text, suggestions } = this.state

    const inputProps = {
      placeholder: 'Search',
      value: text,
      onChange: this.onChange.bind(this),
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyDown: this.onKeyDown.bind(this),
    }

    return (
      <div className={classnames(
          'hbox search',
          {
            'search--focused': focused,
            'search--has-text': text && text.length > 0
          }
      )}>
        <i className="fa fa-search search__icon"></i>

        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
        
        {/*<input
          className='search-input'
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onKeyDown={this.onKeyDown}
          onChange={this.onChange}
          value={text}>
        </input>*/}
        { this.state.text && <i className="fa fa-times-circle" onClick={this.clearSearch}></i> }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Search/Search.js